import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

import { ButtonLink, InfoValue } from '../../AccountSettings.style';

export const EmailRow = superstyled({
  tag: Stack,
  name: 'EmailVerificationStatus',
  slot: 'EmailRow',
  styles: () => ({
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '0.5rem',
  }),
});

export const EmailValue = superstyled({
  tag: InfoValue,
  name: 'EmailVerificationStatus',
  slot: 'EmailValue',
});

export const ResendLink = superstyled({
  tag: ButtonLink,
  name: 'EmailVerificationStatus',
  slot: 'ResendLink',
  styles: () => ({
    minHeight: 'auto',
  }),
});
